module.exports = __webpack_public_path__ + "img/homepage-separator.b79cfb26.png";